import './libraries/slimmageSettings';
import './libraries/slimmage';
import Lity from 'lity';

// App
import App from './app';
import PolyfillController from './controllers/polyfill';

// Controllers
import HeaderController from './controllers/header';
import MediaController from './controllers/media';
// import AVGController from './controllers/avg';
import SliderController from './controllers/slider';
import AccordeonController from './controllers/accordeon/controller';
import MapController from './controllers/map';
import BannerController from './controllers/banner';

// Page specific
import PanelOverviewController from './controllers/panelOverview';

// Cosmetic
import ParallaxController from './controllers/parallax';

// Fader
import Fader from './libraries/fader';
let fades = [];
fades.push('#hero.home .background');
fades.push('#hero.home .imageColumn');
fades.push('#hero.home .contentColumn');
fades.push('#hero.home .continueColumn');

fades.push('.alternatingBlocks .row > *');

fades.push('main a');
fades.push('main p');
fades.push('main h2');
fades.push('main h3');
fades.push('main h4');
fades.push('main h5');
fades.push('main li');

fades.push('#prefooter .image');
fades.push('#prefooter h2');
fades.push('#prefooter h2 + p');
fades.push('#prefooter address .row');
fades.push('footer a');

(async () => {
    document.querySelector('html').classList.remove('no-js');

    const polyfills = new PolyfillController();
    await polyfills.init();

    try {
        const app = new App();
        app.resizeThrottle = 10;
        app.scrollThrottle = 100;
        window.app = app;
    
        app.polyfillController = polyfills;
    
        // app.AVGController = new AVGController();
        app.headerController = new HeaderController();
        app.mediaController = new MediaController();
        app.sliderController = new SliderController();
        app.accordeonController = new AccordeonController();
        app.mapController = new MapController();
        app.bannerController = new BannerController();
        app.panelOverviewCcontroller = new PanelOverviewController();
        app.parallaxController = new ParallaxController();

        // Modules
        const loadModules = () => {
            if (document.querySelector('[data-gallery]')) {
                import( /* webpackChunkName: "modules/gallery" */ './controllers/gallery').then(e => {
                    app.galleryController = new e.default();
                });
            }

            if (document.querySelector('section.filesOverview')) {
                import( /* webpackChunkName: "modules/filesOverview" */ './controllers/filesOverview').then(e => {
                    app.filesOverviewController = new e.default();
                });
            }

            if (document.querySelector('.newsOverview')) {
                import( /* webpackChunkName: "modules/overview" */ './controllers/newsOverview').then(e => {
                    app.pagedOverviewController = new e.default(document.querySelector('.newsOverview'));
                });
            }

            if (document.querySelector('section.blRatesGraph')) {
                import( /* webpackChunkName: "modules/ratesGraph" */ './controllers/ratesGraph').then(e => {
                    app.ratesGraphController = new e.default();
                });
            }
        };

        loadModules();

        await app.init();

        // Add a fader listener
        let fader = new Fader(fades.join(','));
        fader.threshold = .2;
        app.fader = fader;

        setTimeout(() => {
            if (document.querySelector(`#colorOverlay`)) {
                document.querySelector(`#colorOverlay`).remove();
            }
        }, 400);

        // Quick script to scroll to a filled in web to case form
        if (document.querySelector('.webToCase.success')) {
            const target = document.querySelector('.webToCase.success');
            if (target.scrollIntoView) {
                console.log('scrolling');
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'start',
                });
            }
        }
    } catch(e) {
        console.error(`Something went wrong initializing the app`);
        throw e;
    };

    console.log(`App initialized`);
    document.documentElement.classList.remove('preventAnimations');

})();